<div class="flex-column">
    <app-card-table themeScope="schedule" [elevated]="true" [metaData]="this.metaDataAttentions" [title]="('modules.schedule.consolidation.consolidacion-de-atenciones' | exp:'':'Consolidación de atenciones')"
        (page)="onPaginatorEvent($event)" (hasNextPage)="this.hasMorePages = $event">
        <div filterInputs class="mat-elevation-z2 mys-4 pxs-3 pbs-3">
            <mat-tab-group dynamicHeight [disableRipple]="false" mat-stretch-tabs="false" mat-align-tabs="center">
                <mat-tab [label]="'modules.schedule.consolidation.filters.tab-filtros' | exp:'':'Filtros'">
                    <!-- Filters -->
                    <form class="flex-column mts-3" *ngIf="filterForm" [formGroup]="filterForm">
                        <div class="flex-row flex-wrap align-space-between-center mb-0 mxs-3">
                            <!-- Select providers -->
                            <div class="flex-column pr-2 flex-30">
                                <span class="subtitle-4 text-primary-darker">
                                    {{'modules.schedule.consolidation.filters.prestador' | exp:'':'Prestador'}}
                                </span>
                                <app-select-searching-dynamic-input class="flex-auto" [name]="this.PROVIDER"
                                    [nameSearching]="this.PROVIDER_SEARCHING" [form]="this.filterForm"
                                    [placeholder]="'modules.schedule.consolidation.placeholders.seleccionar' | exp:'':'Seleccionar'" [calculateId]="this.calculateIdProvider"
                                    [calculateName]="this.calculateNameProvider" [placeholderNoValue]="'modules.schedule.consolidation.placeholders.sin-resultados' | exp:'':'Sin resultados'"
                                    [placeholderSearching]="'modules.schedule.consolidation.placeholders.buscar-prestador' | exp:'':'Buscar prestador...'"
                                    [httpGet]="this.getProvidersByFullName">
                                </app-select-searching-dynamic-input>
                            </div>
                            <!-- Select patients -->
                            <div class="flex-column pr-2 flex-30">
                                <span class="subtitle-4 text-primary-darker">
                                    {{'modules.schedule.consolidation.filters.paciente' | exp:'':'Paciente'}}
                                </span>
                                <app-select-searching-dynamic-input class="flex-auto" [name]="this.PATIENT"
                                    [nameSearching]="this.PATIENT_SEARCHING" [form]="this.filterForm"
                                    [placeholder]="'modules.schedule.consolidation.placeholders.seleccionar' | exp:'':'Seleccionar'" [calculateId]="this.calculateIdPatient"
                                    [calculateName]="this.calculateNamePatient" [placeholderNoValue]="'modules.schedule.consolidation.placeholders.sin-resultados' | exp:'':'Sin resultados'"
                                    [placeholderSearching]="'modules.schedule.consolidation.placeholders.buscar-paciente' | exp:'':'Buscar paciente...'"
                                    [httpGet]="this.getPatientsByNameAndSurname"
                                    [defaultValue]="!!this.patientOnSelect ? this.actualPatient[0] : null"
                                    [elements]="!!this.patientOnSelect ? this.patientOnSelect[0] : null">
                                </app-select-searching-dynamic-input>
                            </div>
                            <!-- Select financiers  -->
                            <div class="flex-column pr-2 flex-30">
                                <span class="subtitle-4 text-primary-darker">
                                    {{'modules.schedule.consolidation.financiador' | exp:'':'Financiador'}}
                                </span>
                                <app-select-searching-dynamic-input class="flex-auto" [name]="this.FINANCIER"
                                    [nameSearching]="this.FINANCIER_SEARCHING" [form]="this.filterForm"
                                    [placeholder]="'modules.schedule.consolidation.placeholders.seleccionar' | exp:'':'Seleccionar'" [calculateId]="this.calculateIdFinancier"
                                    [calculateName]="this.calculateNameFinancier"
                                    [placeholderNoValue]="'modules.schedule.consolidation.placeholders.sin-resultados' | exp:'':'Sin resultados'"
                                    [placeholderSearching]="('modules.schedule.consolidation.buscar-financiador' | exp:'':'Buscar financiador')"
                                    [httpGet]="this.getFinanciersByName"
                                    [defaultValue]="!!this.financierOnSelect ? this.actualFinancier[0] : null"
                                    [elements]="!!this.financierOnSelect ? this.financierOnSelect[0] : null">
                                </app-select-searching-dynamic-input>
                            </div>
                        </div>
                        <div class="flex-row flex-wrap align-center-center gap-1rem">
                            <!-- Select fromDate -->
                            <div class="flex-column pr-2">
                                <span class="subtitle-4 text-primary-darker">
                                    {{'modules.schedule.consolidation.filters.desde' | exp:'':'Desde'}}
                                </span>
                                <div class="flex-row align-start-center">
                                    <app-date-picker [name]="this.FROM_DATE" [form]="this.filterForm"
                                        [placeholder]="('modules.schedule.consolidation.fecha-desde' | exp:'':'Fecha desde')">
                                    </app-date-picker>
                                </div>
                            </div>
                            <!-- Select ToDate -->
                            <div class="flex-column pr-2">
                                <span class="subtitle-4 text-primary-darker">
                                    {{'modules.schedule.consolidation.filters.hasta' | exp:'':'Hasta'}}
                                </span>
                                <div class="flex-row align-start-center">
                                    <app-date-picker [name]="this.TO_DATE" [form]="this.filterForm"
                                        [placeholder]="('modules.schedule.consolidation.fecha-hasta' | exp:'':'Fecha hasta')">
                                    </app-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="flex-row align-space-around-center">
                            <app-checkbox-input [form]="filterForm" [label]="'modules.schedule.consolidation.filters.informadas' | exp:'':'Informadas'"
                                [name]="this.INFORMED_STATE_ATTENTION">
                            </app-checkbox-input>
                            <app-checkbox-input [form]="filterForm" [label]="('modules.schedule.consolidation.no-informadas' | exp:'':'No Informadas')"
                                [name]="this.NOT_INFORMED_STATE_ATTENTION">
                            </app-checkbox-input>
                            <app-checkbox-input [form]="filterForm" [label]="'modules.schedule.consolidation.filters.facturables' | exp:'':'Facturables'"
                                [name]="this.BILLABLE_STATE_ATTENTION">
                            </app-checkbox-input>
                            <app-checkbox-input [form]="filterForm" [label]="'modules.schedule.consolidation.filters.debitadas' | exp:'':'Debitadas'"
                                [name]="this.DEBITED_STATE_ATTENTION">
                            </app-checkbox-input>
                            <app-checkbox-input [form]="filterForm" [label]="('modules.schedule.consolidation.en-proceso' | exp:'':'En Proceso')"
                                [name]="this.IN_PROCESS_STATE_ATTENTION">
                            </app-checkbox-input>
                        </div>
                    </form>
                    <!-- Buttons -->
                    <div *ngIf="this.filterForm" class="mts-3 flex-row align-center">
                        <button *ngIf="this.patientForm || this.financierForm || this.providerForm || this.toDateForm || this.fromDateForm ||
                            this.informedAttentionForm || this.notInformedAttentionForm ||this.billableAttentionForm ||this.debitedAttentionForm || this.inProcessAttentionForm"
                            mat-stroked-button [color]="'primary'" (click)="resetValuesDialog()" class="mx-3"
                            id="Consolidations_btnRemoveFilters">
                            {{ 'modules.schedule.consolidation.borrar-filtros' | exp:'':'Borrar Filtros' }}
                        </button>
                        <button (click)="onFilterAttentions()" mat-flat-button [color]="'primary'" type="submit" id="Consolidations_btnSearch">{{ ('modules.schedule.consolidation.filters.buscar' | exp:'':'Buscar')  }}</button>
                    </div>
                </mat-tab>
                <mat-tab [label]="'modules.schedule.consolidation.liquidaciones.tab-liquidaciones' | exp:'':'Liquidaciones'">
                    <form class="flex-column mts-4" *ngIf="filterLiquidationForm" [formGroup]="filterLiquidationForm"
                        (submit)="this.onSearchAttentionsByLiquidation()">
                        <div class="flex-row align-space-evenly-center gap-1rem">
                            <!-- Select financiers -->
                            <div class="flex-column pr-2 flex-30">
                                <span class="subtitle-4 text-primary-darker">
                                    {{'modules.schedule.consolidation.financiador' | exp:'':'Financiador'}}
                                </span>
                                <app-select-searching-dynamic-input class="flex-auto" [name]="this.FINANCIER"
                                    (selected)="this.onSelectFinancierLiquidation($event)"
                                    [nameSearching]="this.FINANCIER_SEARCHING" [form]="this.filterLiquidationForm"
                                    [placeholder]="'modules.schedule.consolidation.placeholders.seleccionar' | exp:'':'Seleccionar'" [calculateId]="this.calculateIdFinancier"
                                    [calculateName]="this.calculateNameFinancier"
                                    [placeholderNoValue]="'modules.schedule.consolidation.placeholders.sin-resultados' | exp:'':'Sin resultados'"
                                    [placeholderSearching]="('modules.schedule.consolidation.buscar-financiador' | exp:'':'Buscar financiador') + '...'"
                                    [httpGet]="this.getFinanciersByName">
                                </app-select-searching-dynamic-input>
                            </div>
                            <!-- Select liquidation -->
                            <div class="flex-column pr-2 flex-30">
                                <span class="subtitle-4 text-primary-darker">
                                    {{ 'modules.schedule.consolidation.liquidacion' | exp:'':'Liquidación' }}
                                </span>
                                <app-select-searching-input #selectLiquidations class="flex-auto"
                                    [disabled]="!this.filterLiquidationForm.get(this.FINANCIER).value"
                                    [name]="this.LIQUIDATION" [nameSearching]="this.LIQUIDATION_SEARCHING"
                                    [form]="this.filterLiquidationForm" [placeholder]="('modules.schedule.consolidation.buscar-liquidacion' | exp:'':'Buscar liquidación')"
                                    [calculateId]="this.calculateIdFinancier"
                                    [calculateName]="this.calculateNameFinancier"
                                    [placeholderNoValue]="'modules.schedule.consolidation.placeholders.sin-resultados' | exp:'':'Sin resultados'"
                                    [placeholderSearching]="('modules.schedule.consolidation.buscar-liquidacion' | exp:'':'Buscar liquidación') + '...'" [elements]="this.liquidations">
                                </app-select-searching-input>
                            </div>
                        </div>
                        <div class="flex-row align-center-center gap-5 mts-2">
                            <button id="btn_consolidationComponentBuscar" mat-flat-button type="submit" color="primary"
                                [disabled]="!this.filterLiquidationForm.valid">{{ ('modules.schedule.consolidation.filters.buscar' | exp:'':'Buscar')  }}</button>
                            <button mat-flat-button type="button" color="primary"
                                [disabled]="!this.filterLiquidationForm.valid || this.loadingPdf"
                                (click)="onGeneratePdf()">
                                <span *ngIf="!this.loadingPdf; else loadingIcon">{{ 'modules.schedule.consolidation.generar-pdf' | exp:'':'Generar Pdf' }}</span>
                            </button>
                            <ng-template #loadingIcon>
                                <mat-icon><mat-spinner color="accent" diameter="20"></mat-spinner></mat-icon>
                            </ng-template>
                        </div>
                    </form>
                </mat-tab>
            </mat-tab-group>
        </div>
        <div table class="mat-elevation-z2">
            @if(isLoadingGetAttentions) {
                <app-spinner></app-spinner>
            }
            <div class="mts-2 flex mat-stretch-tabs" *ngIf="this.attentions">
                <div class="flex-column align-center-none table-container full-width">
                    <app-attentions-list
                        [title]="this.metaDataAttentions && !!this.metaDataAttentions.liquidationId ? (this.attentions.length == 0 ? ('modules.schedule.consolidation.table.atenciones-filtradas-por-liquidacion' | exp:'':'Atenciones filtradas por liquidación') : ('modules.schedule.consolidation.table.atenciones-de-la-liquidacion' | exp:{name: this.attentions[0]?.liquidation?.name}:'Atenciones de la liquidación: ' + this.attentions[0]?.liquidation?.name)) : ('modules.schedule.consolidation.table.atenciones-por-filtro-manual' | exp:'':'Atenciones por filtro manual')"
                        [ruleClickable]="this.attentionsService.isInformable" class="flex-100"
                        [ruleSelectable]="this.canSelectInConsolidation.bind(this)"
                        (onClickButton1)="this.onClickInformAttentions($event)" [textButton1]="('modules.schedule.consolidation.table.informar' | exp:'':'Informar') "
                        [ruleEnabledButton1]="this.canInformSelected.bind(this)"
                        [colorButton1]="'primary'" [infoTextButton1]="''"
                        [textButton2]="this.isAdmin ? ('modules.schedule.consolidation.table.revertir-informadas' | exp:'':'Revertir informadas') : null"
                        (onClickButton2)="this.onClickRevertInformadas($event)"
                        [ruleEnabledButton2]="this.canRevertInformadas.bind(this)"
                        [attentions]="this.filterDeliveryPractice()"
                        [columnsToShow]="['arrow','checkbox','type','fromDate','provider','practice','financier','patient','documentNumber','state','signature','evolutions']"
                        [textNoAttentions]="'modules.schedule.consolidation.table.no-existen-atenciones-a-consolidar' | exp:'':'No existen atenciones a consolidar para este mes según los filtros establecidos'"
                        [loading]="this.isLoadingGetAttentions" [showMonth]="false" [paginatorOn]='false'
                        [scrollOn]='false' [paginatorServerSide]="true" [clearSelection]="this.clearSelection"
                        [noSort]='true' [showReload]="false"
                        class="full-width">
                    </app-attentions-list>
                    @if(hasMorePages) {
                        <div class="flex-row mts-3 align-center-center full-width flex">
                            <app-warning-icon style="display: flex; width: 50px;"></app-warning-icon>
                            <span class="text-secondary-darker">{{ 'modules.schedule.consolidation.aun-tiene-paginas-por-recorrer' | exp:'':'Aún tiene páginas por recorrer' }}</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    </app-card-table>
</div>

<ng-template #reportTemplate>
    <!-- Spinner -->
    <div class="spinner-hover" *ngIf="this.informingAttentions">
        <mat-spinner color="primary" diameter="40"></mat-spinner>
    </div>
    <div class="text-secondary align-start-center">
        <mat-icon class="mat-icon-small">info</mat-icon>
        {{ 'modules.schedule.consolidation.seleccione-la-liquidacion-que-se-asociara-a-las-atenciones' | exp:'':'Seleccione la liquidación que se asociará a las atenciones' }}
    </div>
    <form class="flex-column mts-4" *ngIf="formReport" [formGroup]="formReport" (submit)="this.informAttentions()">
        <!-- Select liquidation -->
        <div class="flex-column">
            <span class="subtitle-3 text-primary-darker mbs-0">
                {{ ('modules.schedule.consolidation.liquidacion' | exp:'':'Liquidación') }} *
            </span>
            <app-select-searching-input #selectReport class="flex-auto" [name]="this.LIQUIDATION"
                [nameSearching]="this.LIQUIDATION_SEARCHING" [form]="this.formReport"
                [placeholder]="('modules.schedule.consolidation.buscar-liquidacion' | exp:'':'Buscar liquidación')" [calculateId]="this.calculateIdFinancier"
                [calculateName]="this.calculateNameFinancier" [placeholderNoValue]="'modules.schedule.consolidation.placeholders.sin-resultados' | exp:'':'Sin resultados'"
                [placeholderSearching]="('modules.schedule.consolidation.buscar-liquidacion' | exp:'':'Buscar liquidación') + '...'" [elements]="this.liquidations">
            </app-select-searching-input>
        </div>
        <!-- Buttons -->
        <div class="flex-row align-center-center gap-5 mts-2">
            <button mat-stroked-button type="button" color="primary" (click)="this._dialogRef.close()">{{('common.cancel' | exp:'':'Cancelar')}}</button>
            <button mat-flat-button type="submit" color="primary"
                [disabled]="!this.formReport.valid || this.informingAttentions">{{ ('modules.schedule.consolidation.table.informar' | exp:'':'Informar')  }}</button>
        </div>
    </form>
</ng-template>


<ng-template #loadingRequest>
    <!-- <div class="flex-100 mts-5 center-center">
        <app-spinner *ngIf="!this.error; else errorDiv" [minHeight]="200"></app-spinner>
    </div> -->
</ng-template>

<ng-template #loadingRequestNotInformed>
    <div class="flex-100 mts-5 center-center">
        <app-spinner *ngIf="!this.errorNotInformed; else errorDiv" class="flex-100 start"></app-spinner>
    </div>
</ng-template>

<ng-template #errorDiv>
    <div class="flex-100 center-center">
        <app-spinner-error></app-spinner-error>
        <span>
            {{ 'modules.schedule.consolidation.ha-ocurrido-un-error-inesperado-intentelo-nuevamente' | exp:'':'Ha ocurrido un error inesperado, inténtelo nuevamente' }}
        </span>
    </div>
</ng-template>

<ng-template #revertingAttentionsTemplate>
    <div class="p-24">
        <app-spinner></app-spinner>
    </div>
</ng-template>
